import css from '@styled-system/css';
import { ThemeStyles } from '@honda-canada/design-system-react';

const themeStyles = new ThemeStyles();

themeStyles.addBaseStyles('MainContainer')(({ theme }) =>
  css({
    display: 'flex',
    width: '100%',
    margin: '12px 0',
    border: `1px solid ${theme.colors.grey[3]}`,
    borderRadius: '3px',
    position: 'relative',
  }),
);

themeStyles.addBaseStyles('HeaderContainer')(
  css({
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
  }),
);

themeStyles.addBaseStyles('ContentContainer')(
  css({
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    height: 'max',
    width: '100%',
    padding: '12px',
  }),
);

themeStyles.addBaseStyles('PreviewContainer')(
  css({
    minHeight: '112px',
    flexShrink: 0,
    width: ['80px', '80px', '154px'],
    borderRadius: '2px 0 0 2px',
    display: 'flex',
    '& *:hover': {
      ':after': {
        display: 'none',
      },
    },
  }),
);

themeStyles.addBaseStyles('PriceContainer')(
  css({
    display: 'flex',
    columnGap: 'xs',
  }),
);

themeStyles.addBaseStyles('LabelCopy')(
  css({
    color: 'grey.0',
  }),
);

export default themeStyles;
